<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="title mar-b-5">Confirm!</h2>
    <div contentContainer class="row">
      <div class="col-lg-12 col-sm-12">
        <h3 class="body-font-size">you are going to logout</h3>
        <h1 style="align-items: center;text-align: center;">{{time}}</h1>
      </div>
    </div>
    <button mat-raised-button actions class="button-container primary" (click) = "confirm(false)">
        Stay
    </button>
    <button mat-raised-button actions class="button-container primary" (click) = "confirm(true)">
      Logout
  </button>
</app-centre-small-opener>